import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import RaceDetails from './RaceDetails';
import { RunningCoursesTab } from './AddCourses/RunningCoursesTab';
import { TriSwimCycleTab } from './AddCourses/TriSwimCycleTab';
import { BuildYourOwnTab } from './AddCourses/BuildYourOwnTab';
import { AddedCourseList } from './AddedCourseList';
import { SimilarRacesModal } from './SimilarRacesModal';
import {setModalState} from '../../../data/ModalsStream';
import { trackGoogleEvent } from '../../../utils/googleEvents';
import {fetchMasterEvent} from '../../../data/MasterEventStreams';
import { ReCaptcha } from 'react-recaptcha-google';
import { withRouter } from 'react-router-dom';

import { connectStream } from '../../../lib/bastetjs/utils/connectStream';

import { Badge } from '../../shared/Badge';
import {
  getCountryStream
} from '../../../data/CountryStateStreams';

import { styles, grey } from './styles';
import { colors } from '../../../shared/styles';

import _ from 'lodash';

import {
  courseBuilderConstants,
  getByoForRaceCatId,
  buildByoCourseName
} from '../../../utils/races/CourseBuilderConstants';

import { toggle } from '../../../shared/util';
import { urlRegex } from '../../../utils/regex';

import moment from 'moment';

import { TabNav } from './TabNav';

import { sectionVerticalSpacing } from './styles';
import {configs} from '../../../configs';

const tabs = {
  runningTabId: 'running',
  triCycleSwimTabId: 'swimming',
  buildYourOwnTabId: 'byo'
};


export class CreateRaceComponent extends Component {
  static propTypes = {
    masterId: PropTypes.string,
    existingEvent: PropTypes.object,
    redirectToNewCreatePage: PropTypes.func.isRequired,
    fetchRacesTypeAhead: PropTypes.func.isRequired,
    fetchCountries: PropTypes.func.isRequired,
    fetchStates: PropTypes.func.isRequired,
    countries: PropTypes.object,

    fetchSimilarRaces: PropTypes.func.isRequired,
    createRace: PropTypes.func.isRequired,

    openStartListModal: PropTypes.bool,
    eventRaces: PropTypes.array,
    t: PropTypes.func
  };

  static defaultProps = {
    openStartListModal: false
  };

  constructor(props) {
    super(props);

    this.state = {
      tab: tabs.runningTabId,
      ...this.stateFromProps(props),
      open: true,
      masterId: this.props.masterId,
      ReCaptchaResponse: null,
    };
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.onLoadRecaptcha    = this.onLoadRecaptcha.bind(this);
    this.verifyCallback     = this.verifyCallback.bind(this);
  }

  onLoadRecaptcha() {
      if (this.captchaElement) {
          this.captchaElement.reset();
      }
  }
  verifyCallback(recaptchaToken) {
    if(recaptchaToken) {
      this.setState({ReCaptchaResponse: recaptchaToken});
    }
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.existingEvent !== nextProps.existingEvent) {
      this.setState(this.stateFromProps(nextProps));
    }
    if(nextProps.countries
      && nextProps.countries.result
      && this.state.fullLocation) {
        this.onPickedCity(this.state.fullLocation, nextProps.countries);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleRequestClose() {
    this.setState({open: false});
  }


  stateFromProps(props) {
    const { existingEvent, t } = props;

    return {
      //race details
      name: existingEvent ? existingEvent.name : '',
      city: existingEvent ? existingEvent.city : '',
      stateProvId: existingEvent ? existingEvent.stateProvID ? existingEvent.stateProvID : 'US_0' : 'US_0',
      date: new Date(),
      url: existingEvent ?
        existingEvent.webSiteURL || existingEvent.siteUri || '' : '',
      websiteValid: true,
      countryId: existingEvent ? existingEvent.countryID : 'US_0',
      selectedStdCourses: {},

      //build your own course state - default is raceCatId 2 (running)
      byo: getByoForRaceCatId(t, 2),

      courses: [],

      //save state
      saveErrors: null,
      isSearchingSimilar: false,
      similarRaces: null,
      isSaving: false,
      hasSaved: false,
      isShowingSimilarRacesModal: false,
      raceExists: false,
      raceUrl: null
    };
  }

  render() {
    const {
      existingEvent,
      fetchRacesTypeAhead,
      redirectToNewCreatePage,
      fetchCountries,
      fetchStates,
      t
    } = this.props;

    const {
      name,
      city,
      stateProvId,
      date,
      url,
      websiteValid,
      courses,
      isMobile,

      isSaving,
      isShowingSimilarRacesModal,
      similarRaces,
      saveErrors,
      countryId,
      raceExists,
      raceUrl
    } = this.state;

    const modalStyle = {};

    return (
      <div className="container" style={this.props.hasFutureDate ? modalStyle : null}>
        <div className='row' style={{textAlign:'left',marginTop: this.props.hasFutureDate ? 0 : 100}}>

          <div className= {this.props.hasFutureDate ? 'col-md-8 col-lg-12' : 'col-md-8 col-lg-8'}>

            <div style={{display:'inline-block'}}>
              <StepHeading badge='1' text={t('Race Details')} />
              <div>
                <RaceDetails
                  name={name}
                  city={city}
                  stateProvId={stateProvId}
                  countryId={countryId}
                  date={date}
                  url={url}
                  websiteValid={websiteValid}
                  isMobile={isMobile}

                  showRequiredFields={!!saveErrors}

                  onPickedName={this.onPickedName}
                  onPickedCity={this.onPickedCity}
                  onPickedCountry={this.onPickedCountry}
                  onPickedStateProvId={this.onPickedStateProvId}
                  onPickedDate={this.onPickedDate}
                  onPickedUrl={this.onPickedUrl}

                  existingEvent={existingEvent}
                  raceExists={raceExists}
                  raceUrl={raceUrl}

                  fetchRacesTypeAhead={fetchRacesTypeAhead}
                  redirectToNewCreatePage={redirectToNewCreatePage}
                  fetchCountries={fetchCountries}
                  fetchStates={fetchStates}
                />
              </div>
            </div>

            {this.renderTabNavigator()}

          </div>


          {!this.props.hasFutureDate && <div className='col-md-4 col-lg-4'>
            <QuickTips t={t}/>
          </div>
          }

        </div>

        <div className='row'>
          <div className='col-md-12 col-lg-12'>
            <AddedCourseList courses={courses} removeCourseByPos={this.removeCourseByPos} t={t} />
          </div>
        </div>

        {
          isShowingSimilarRacesModal &&
          <SimilarRacesModal
            isMobile={isMobile}
            isSaving={isSaving}
            similarRaces={similarRaces}
            name={name}
            city={city}
            date={date}
            onDismiss={this.handleSimilarRacesDismiss}
            onForceSave={this.handleForceSaveEventClick}
          />
        }

        <ReCaptcha
          ref={(el) => {this.captchaElement = el;}}
          render="explicit"
          sitekey={configs.recaptchaKey}
          onloadCallback={this.onLoadRecaptcha}
          verifyCallback={this.verifyCallback}
        />

        <div className='row'>
          <div className='col-md-12 col-lg-12'>
            {this.renderSaveButton()}
          </div>
        </div>

        </div>
    );
  }

  //MAIN API CALLs

  checkSimilarRacesThenCreate(raceData) {
    const { fetchSimilarRaces } = this.props;

    this.setState({
      saveErrors: null,
      similarRaces: null,
      isSearchingSimilar: true
    }, () => {
      fetchSimilarRaces(raceData)
        .then((similarRaces) => {
          if (this.unmounted) {
            return;
          }
          this.setState({
            isSearchingSimilar: false,
            similarRaces
          });
          //If we have similar races, show the modal
          if (similarRaces && similarRaces.length > 0) {
            this.showSimilarRacesModal();
          } else {
            this.doCreateRace(raceData);
          }
        }, (error) => {
          if (this.unmounted) {
            return;
          }
          this.setState({
            isSearchingSimilar: false,
            saveErrors: error
          })
        });
    });
  }

  doCreateRace(raceData) {
    const { createRace, handleRequestClose, openStartListModal, history } = this.props;

    this.setState({
      isSaving: true,
      hasSaved: false,
      saveErrors: null
    }, () => {
      createRace(raceData)
        .then((response) => {
          if (this.unmounted) {
            return;
          }
          this.setState({
            isSaving: false,
            hasSaved: true,
            isShowingSimilarRacesModal: false
          });
          setTimeout(() => {
            if (this.unmounted) {
              return;
            }
            this.setState({
              hasSaved: false
            });
          }, 7000);
          const {masterId} = this.props;
          masterId && fetchMasterEvent(masterId);
          setModalState('event-calendar', openStartListModal);
          if (handleRequestClose){
            handleRequestClose();
          }
          else {
            const {result: {masterEventId}} = response;
            history.push(`/event/${masterEventId}`);
          }
        }, (error) => {
          if (this.unmounted) {
            return;
          }
          this.setState({
            isSaving: false,
            isShowingSimilarRacesModal: false,
            saveErrors: error
          })
        });
    });
  }
  /**
   * If use value from geoLocation component there is city object and we use description value to get city,
   * else if parse city value from already set value
   * @param city
   */
  countryByLocation(city){
    const cityValue = city.description || city;
    const splitCity = cityValue.split(', ');

    if (splitCity[2]) {
      return splitCity[2];
    } else {
      return splitCity[1];
    }
  }

  /**
   * From posted city and country value get stateProv value
   * @param citySplit
   * @param country
   * @returns {*}
   */
  getStateProv(citySplit, country){
    if (citySplit.length === 3) return citySplit[1];
    else return `${country}_0`;
  }

  /**
   * Return parsed values for city, state and country
   * @param city
   * @returns {{cityVal, stateProv: (null|string), countryID: *}}
   */
  stateCountryValues = (city, fetchedCountries) => {
    const { countries } = this.props;
    const cityValue = city.description || city;
    const citySplit = cityValue.split(', ');

    const cityVal = citySplit[0];
    const countryByLocation = this.countryByLocation(city) || '';
    const countryList = fetchedCountries || countries;
    const country = city && countryList && countryList.result && countryList.result.find(
      (res) => res.Name === countryByLocation || res.CountryID === countryByLocation || res.CountryID3 === countryByLocation
    ) || {};

    return {
      cityVal,
      stateProv: this.getStateProv(citySplit, country.CountryID),
      countryID: country.CountryID
    };
  };


//HANDLERS

  onPickedName = (name) => {
    this.setState({
      name
    });
  };

  onPickedCity = (pickedCity, countries) => {
    const { existingEvent } = this.props;
    const haveExistingEvent = existingEvent && !existingEvent.isLoading;

    const ccsValues = pickedCity && this.stateCountryValues(pickedCity, countries);
    const city = haveExistingEvent ? existingEvent.city : ccsValues.cityVal;
    const countryId = haveExistingEvent ? existingEvent.countryID : ccsValues.countryID;
    const stateProvId = haveExistingEvent ? existingEvent.stateProvID : ccsValues.stateProv;

    this.setState({
      fullLocation: pickedCity,
      city,
      countryId,
      stateProvId: stateProvId.split('_').length > 1 ? stateProvId : `${countryId}_${stateProvId}`
    });
  };

  onPickedStateProvId = (stateProvId) => {
    this.setState({
      stateProvId
    });
  };

  onPickedCountry = (countryId) => this.setState({countryId});

  onPickedDate = (date) => {
    const {eventRaces} = this.props;
    const existingRace = eventRaces && eventRaces.find((race) =>
      new Date(race.raceDate).toLocaleString().split(',')[0] === new Date(date).toLocaleDateString());

    this.setState({
      date,
      raceExists: !!existingRace,
      raceUrl: existingRace ? `${configs.bragiUrl}/event/${existingRace.masterEventID}/results/Event/${existingRace.raceID}` : null
    });
  };

  onPickedUrl = (url) => {
    this.setState({
      url,
      websiteValid: url.length > 0 ? urlRegex.test(url) : true
    })
  };

  handleTabSelect = (e) => {
    e.stopPropagation();
    this.setState({
      tab: e.target.id
    });
  };

  handleSaveEventClick = () => {
    trackGoogleEvent('Race', 'Click', 'Create Race');
    this.checkSimilarRacesThenCreate(this.getRaceData());
  };

  handleForceSaveEventClick = () => {
    this.doCreateRace(this.getRaceData());
  };

  handleSimilarRacesDismiss = () => {
    this.setState({
      isShowingSimilarRacesModal: false
    });
  };

  showSimilarRacesModal() {
    this.setState({
      isShowingSimilarRacesModal: true
    })
  }

  //STANDARD COURSES
  onStdCourseToggled = (cpid, isSelected, course) => {
    const selectedStdCourses = toggle(cpid, this.state.selectedStdCourses, isSelected);
    const courses = [...this.state.courses];

    if (isSelected) {
      _.remove(courses, function(item) {
        return item.cpid === cpid;
      });
    } else {
      courses.push({
        cpid,
        name: course.label,
        legInfo: null, // Standard courses have no leg info because CoursePatternID is already known
        raceCat: 0 // No need to specify Race Category for known Course Pattern
      });
    }

    this.setState({
      selectedStdCourses,
      courses
    });
  };

  //BUILD YOUR OWN COURSES
  setByoRaceCategory = (raceCatId) => {
    const {
      t
    } = this.props;

    this.setState({
      byo: getByoForRaceCatId(t, raceCatId)
    })
  };

  setByoCourseName = (courseName) => {
    this.setState({
      byo: {
        ...this.state.byo,
        courseName
      }
    });
  };

  addByoLeg = () => {
    const {
      t
    } = this.props;
    const byo = {
      ...this.state.byo,
      legs: [...this.state.byo.legs, {dist: '', distKind: 7, actionCat: 0}]
    };

    this.setState({
      byo: {
        ...byo,
        courseName: buildByoCourseName(t, byo)
      }
    });
  };

  removeByoLeg = () => {
    const {
      t
    } = this.props;
    const byo = {
      ...this.state.byo,
      legs: this.state.byo.legs.slice(0, -1)
    };

    this.setState({
      byo: {
        ...byo,
        courseName: buildByoCourseName(t, byo)
      }
    });
  };

  addByoCourse = () => {
    const {
      t
    } = this.props;
    const { byo } = this.state;

    const isMulti = byo && byo.raceCat && byo.raceCat.isMulti;

    let legInfo;
    if (isMulti) {
      legInfo = (byo.legs || []).reduce((res, l) => {
        return res + l.actionCat + ':' + l.dist + ':' + l.distKind + ';';
      }, '', this);
    } else {
      const leg0 = byo.legs[0];
      const actionCat = courseBuilderConstants(t).RACE_CAT_TO_ACTION_CAT_MAP[byo.raceCat.raceCatId];
      legInfo = actionCat + ':' + leg0.dist + ':' + leg0.distKind + ';';
    }

    const courses = [...this.state.courses];
    courses.push({
      cpid: 0, // Custom courses has no known CoursePatternID
      name: byo.courseName,
      legInfo,
      raceCat: byo.raceCat.raceCatId
    });

    //Clear byo
    this.setState({

      courses,

      byo: getByoForRaceCatId(t, byo.raceCat.raceCatId)

    });
  };

  setByoLegDistance = (legNo, dist) => {
    const {
      t
    } = this.props;
    const legs = [...this.state.byo.legs];

    if (legNo < 0 || legNo >= legs.length) return;

    legs[legNo].dist = dist;

    const byo = {
      ...this.state.byo,
      legs
    };

    this.setState({
      byo: {
        ...byo,
        courseName: buildByoCourseName(t, byo)
      }
    });
  };

  setByoLegDistanceKind = (legNo, distKind) => {
    const legs = [...this.state.byo.legs];

    if (legNo < 0 || legNo >= legs.length) return;

    legs[legNo].distKind = distKind;

    const byo = {
      ...this.state.byo,
      legs
    };

    this.setState({
      byo: {
        ...byo,
        courseName: buildByoCourseName(t, byo)
      }
    });
  };

  setByoLegActionCategory = (legNo, actionCat) => {
    const legs = [...this.state.byo.legs];

    if (legNo < 0 || legNo >= legs.length) return;

    legs[legNo].actionCat = actionCat;

    const byo = {
      ...this.state.byo,
      legs
    };

    this.setState({
      byo: {
        ...byo,
        courseName: buildByoCourseName(t, byo)
      }
    });
  };

  //REMOVE COURSE
  removeCourseByPos = (pos, cpid) => {
    const { courses } = this.state;
    if (pos < 0 || pos >= courses.length) {
      return;
    }

    const selectedStdCourses = cpid
      ? toggle(cpid, this.state.selectedStdCourses, true) : this.state.selectedStdCourses;

    const newCourses = [...courses];
    newCourses.splice(pos, 1);
    this.setState({
      courses: newCourses,
      selectedStdCourses
    })
  };

  getRaceData() {
    const {
      masterId,
      name,
      stateProvId,
      date,
      url,
      courses,
      city,
      ReCaptchaResponse
    } = this.state;

    const momentDate = moment(date);
    const hh = momentDate.hours();
    const mm = momentDate.minutes();

    //TODO mimicking what's done in prod - want the selected time to be in GMT
    const startDateTime = moment.utc(moment(date).format('YYYY-MM-DD')).hours(hh).minutes(mm).toJSON();

    return {
      name,
      startDateTime,
      masterEventId: masterId,
      stateProvId,
      city,
      url,
      courses,
      ReCaptchaResponse
    };
  }

  renderActiveTab(tab) {
    const { selectedStdCourses } = this.state;

    switch (tab) {
      case tabs.runningTabId:
        return (
          <RunningCoursesTab
            selectedStdCourses={selectedStdCourses}
            onStdCourseToggled={this.onStdCourseToggled}
            t={this.props.t}
          />
        );

      case tabs.triCycleSwimTabId:
        return (
          <TriSwimCycleTab
            selectedStdCourses={selectedStdCourses}
            onStdCourseToggled={this.onStdCourseToggled}
            t={this.props.t}
          />
        );

      case tabs.buildYourOwnTabId:
        const { byo } = this.state;
        return (
          <BuildYourOwnTab
            byo={byo}
            setByoRaceCategory={this.setByoRaceCategory}
            setByoCourseName={this.setByoCourseName}
            addByoLeg={this.addByoLeg}
            removeByoLeg={this.removeByoLeg}
            addByoCourse={this.addByoCourse}
            setByoLegDistance={this.setByoLegDistance}
            setByoLegDistanceKind={this.setByoLegDistanceKind}
            setByoLegActionCategory={this.setByoLegActionCategory}
            t={this.props.t}
          />
        );

      default:
        throw new Error('Unknown tab: ' + tab);
    }
  }

  renderTabNavigator() {
    const {
      t
    } = this.props;
    const { tab } = this.state;

    return (
      <div style={{marginTop: sectionVerticalSpacing}}>
        <StepHeading badge='2' text={t('Add Courses')} />

        <div  style={{marginTop: 20, marginBottom: 20}}>
          <TabNav>
            {this.renderTabHeaderLink(tabs.runningTabId, tab === tabs.runningTabId, t('Running Courses'))}
            {this.renderTabHeaderLink(tabs.triCycleSwimTabId, tab === tabs.triCycleSwimTabId, t('Tri, Cycling & Swim Courses'))}
            {this.renderTabHeaderLink(tabs.buildYourOwnTabId, tab === tabs.buildYourOwnTabId, t('Build Your Own'))}
          </TabNav>
        </div>

        <div>
          {this.renderActiveTab(tab)}
        </div>
      </div>
    );
  }

  renderSaveButton() {
    const {
      t
    } = this.props;
    const { courses, raceExists, isSaving, hasSaved, isSearchingSimilar, name, websiteValid, ReCaptchaResponse } = this.state;

    const noCourses = !courses || courses.length === 0;

    let text, disabled;

    if (isSaving) {
      text = t('Saving Event...');
    } else if (isSearchingSimilar) {
      text = t('Searching similar races...');
    } else if (noCourses) {
      text = t('Save Event');
    } else if (hasSaved) {
      text = t('Race Created!');
    } else {
      text = t('Save Event');
    }

    disabled = !_.trim(name) || raceExists || noCourses || isSaving || hasSaved || isSearchingSimilar || !websiteValid || !ReCaptchaResponse;

    return (
      <div style={{textAlign: this.props.handleRequestClose ? 'right' : 'left', marginTop:10}}>
        {/*{this.props.handleRequestClose &&*/}
        {/*<FlatButton*/}
        {/*  backgroundColor={colors.white}*/}
        {/*  style={{*/}
        {/*    paddingLeft:20,*/}
        {/*    paddingRight:20,*/}
        {/*    color: '#4a4a4a'*/}
        {/*  }}*/}
        {/*  label={t('Cancel')}*/}
        {/*  onTouchTap={this.props.handleRequestClose}*/}
        {/*/>}*/}
        {/*<FlatButton*/}
        {/*  id='save-event-button'*/}
        {/*  className={text}*/}
        {/*  backgroundColor={!disabled? colors.blue: grey}*/}
        {/*  hoverColor={colors.blue}*/}
        {/*  style={{*/}
        {/*    paddingLeft:20,*/}
        {/*    paddingRight:20,*/}
        {/*    color:'white'*/}
        {/*    }}*/}
        {/*  label={text}*/}
        {/*  primary={true}*/}
        {/*  disabled={disabled}*/}
        {/*  onTouchTap={this.handleSaveEventClick}*/}
        {/*/>*/}
      </div>
    );
  }

  renderTabHeaderLink(id, isActive, text) {
    return (
      <div style={{display: 'inline-block',
                lineHeight: '25px',
                marginRight: 28,
                borderBottom: '3px solid transparent',
                borderBottomColor: isActive? colors.blue : 'transparent',
                color: isActive? 'grey': 'lightgrey'}}
         onClick={this.handleTabSelect}
         id={id}>
        {text}
      </div>
    );
  }
}

export const CreateRace = withTranslation()(connectStream({
  countries: getCountryStream
})(withRouter(CreateRaceComponent)));


const liStyle = {
  color: colors.blue,
  marginBottom:10
};
const tipText = {
  fontSize:'12px',
  color:'grey'
};

const QuickTips = ({t}) => {
  return (
    <div style={{marginBottom: 40}}>
      <div id='add-race-tips-heading' style={styles.stepHeading}>
        {t('Quick Tips for Adding a Race')}
      </div>
      <div style={{...tipText, marginTop: 15, marginBottom: 10}}>
        {t('To ensure that your event is saved correctly: ')}
      </div>
      <ul style={{listStyleType:'disc', paddingLeft: 25}}>
        <li style={liStyle}>
          <span style={tipText}>
            {t('Enter the correct date. For multi-day events, enter the start date.')}
          </span>
        </li>
        <li style={liStyle}>
          <span style={tipText}>
            {t('Enter a valid URL (Web site address) so that our team can '
              + 'find the results or contact the race director.')}
          </span>
        </li>
        <li style={liStyle}>
          <span style={tipText}>
            {t('Add one or more courses.')}
          </span>
        </li>
      </ul>
    </div>
  );
};

const StepHeading = ({badge, text}) => {
  return (
    <div style={styles.stepHeading}>
      <Badge
        size={18}
        label={badge}
        style={{
          backgroundColor: colors.blue,
          marginRight: 10,
          verticalAlign: 'middle',
          color: 'white',
          fontSize: '12px'
        }}
      />
      <span style={{display: 'inline-block', verticalAlign: 'middle'}} className={'race-details-header'}>
        {text}
      </span>
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./components/race/create/CreateRace.js
 **/